<template>
  <div class="game-luar">
    <button @click="voice"> voice </button>
    <PlayerInRoom/>
    <!-- <div class="game-container mx-auto flex">
      <audio loop id="start" src="../assets/Battle_Music_1.mp3" type="audio/mpeg" />
      <div id="player" class="w-1/4">
        <PlayerCard :player="player" />
        <br />
        <br />
        <PlayerCard :player="player" />
        <button
            @click="getResource"
            class="  text-green-900 btn-cus"
          >
            <audio id="get-resource" src="../assets/get-resource.mp3" type="audio/mpeg" />
            GET RESOURCES
          </button>
      </div>
      <div id="bord" class="w-3/4">
      
        <div class="flex justify-end">
          <div>
            <button v-if="isSound" @click="startAudio" class="flex items-center mr-3">
              <i class="fa fa-volume-off fa-2x" aria-hidden="true"></i>
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            <button v-else @click="stopAudio">
              <i class="fa fa-volume-up fa-2x" aria-hidden="true"></i>
            </button>
          </div>
          <button>
            <i class="fa fa-sign-out fa-2x mr-3" aria-hidden="true"></i>
          </button>
        </div>

        <div class="mx-auto">
          <div class="w-1/3 mx-auto">
            <div id="tile" class="p-10 m-2 bg-gray-400 text-center font-bold rounded">
              <p>CURRENT LOCATION</p>
            </div>
          </div>
        </div>
        <div id="button" class="flex p-10 justify-center">
          <button
            @click="playMarket"
            class="px-4 py-2 m-2 bg-green-200 text-green-900 text-center rounded shadow"
          >
            <audio id="market" src="../assets/market-coin.mp3" type="audio/mpeg" />
            SELL
          </button>
          <button
            @click.prevent="move1"
            class="px-4 py-2 m-2 bg-green-200 text-green-900 text-center rounded shadow"
          >Move-1</button>
          <button
            class="px-4 py-2 m-2 bg-green-200 text-green-900 text-center rounded shadow"
          >CALL ASSISTANT</button>
          <button
            @click="dice"
            class="px-4 py-2 m-2 bg-green-200 text-green-900 text-center rounded shadow"
          >
            <audio id="dadu" src="../assets/dadu.mp3" type="audio/mpeg" />
            Gamble
          </button>
          <button
            @click="getResource"
            class=" m-2 btn-cus text-green-900 text-center rounded shadow"
          >
            <audio id="get-resource" src="../assets/get-resource.mp3" type="audio/mpeg" />
            GET RESOURCES
          </button>

          <button
            @click="updateCart"
            class="px-4 py-2 m-2 bg-green-200 text-green-900 text-center rounded shadow"
          >
            <audio id="update-cart" src="../assets/update-cart.mp3" type="audio/mpeg" />
            Upgrade Cart
          </button>
        </div>
        <div id="tiles" class="flex flex-wrap">
          <TileCard v-for="(n,i) in 6" :key="i" :index="i" :player1="player1" :player2="player2" />
        </div>
      </div>
    </div>-->
    <!-- <button class="btn-cus">testttt</button> -->

    <div class="container">
      <div class="avatar floating"></div>
    </div>
  </div>
</template>

<script>
import Artyom from "artyom.js";
import PlayerCard from "../components/PlayerCard";
import TileCard from "../components/TileCard";
import PlayerInRoom from "../components/PlayerInRoom"
export default {
  name: "Test",
  components: {
    PlayerCard,
    TileCard,
    PlayerInRoom
  },
  data: function () {
    return {
      player: {
        name: "Nicko",
      },
      isSound: true,
      player1: "",
      player2: "",
      currentLocation: "",
    };
  },
  methods: {
    voice() {
      const moveTo = 'Luxury Shop'
      const Jarvis = new Artyom();

      Jarvis.say(`Move to ${moveTo} !`);
    },
    startAudio() {
      var audio = document.getElementById("start");
      audio.play();
      audio.volume = 0.05;
      this.isSound = false;
    },
    stopAudio() {
      var audio = document.getElementById("start");
      audio.pause();
      this.isSound = true;
      // audio.volume = 0.1;
    },
    playMarket() {
      var audio = document.getElementById("market");
      audio.play();
    },
    updateCart() {
      var audio = document.getElementById("update-cart");
      audio.play();
    },
    dice() {
      var audio = document.getElementById("dadu");
      audio.play();
    },
    getResource() {
      var audio = document.getElementById("get-resource");
      audio.play();
    },
    move1() {
      this.player1++;
    },
  },
  created() {},
  computed: {
    locationIn() {
      if (this.currentLocation) {
      }
      return;
    },
  },
};
</script>
<style>
/* .avatar {
	width: 150px;
	height: 150px;
	box-sizing: border-box;
	border: 5px white solid;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);
	transform: translatey(0px);
	animation: 6s ease-in-out infinite;
	
} */

/* .avatar img { width: 100%; height: auto; } */
</style>

/* .btn-cus {
  background-image: url("../assets/btn-1.png");
  background-size: auto;
  background-repeat: no-repeat;

}

.avatar {
	width: 150px;
	height: 150px;
	box-sizing: border-box;
	border: 5px white solid;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);
	transform: translatey(0px);
	animation: float 6s ease-in-out infinite;
	
}

.avatar img { 
  width: 100%;
  height: auto;
} */
/* .game-container {
  width: 1350px;

  /* height: ; 
}

/* .game-luar {
  background-image: url("../assets/background.jpeg");
  width: 100vw;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
} */
